module.exports = __webpack_public_path__ + "src/assets/img/logo_pagbrasil.9085c56e.svg";